import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Spinner from '../assets/Spinner';

const PrivateRoute = ({
  component: Component,
  auth: { isAuthenticated, loading }
}) => {
  if (loading) return <Spinner />;
  if (isAuthenticated){console.log('isAuthenticated = true', localStorage.token.value)}
   
   let t =JSON.stringify(localStorage.token)
   console.log("t = " + t)  
    return <Component />
  

  // return <Navigate to={`/openai/m1/select/${t}`} />;
};

PrivateRoute.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default connect(mapStateToProps)(PrivateRoute);
